@if (!isEditMode) {
  <div class="table-content" title="{{cellValue}}">
    <input class="form-control" [(ngModel)]="cellValue" type="number" max="1" maxlength='1' (blur)="blurAction()" autofocus>
  </div>
}
@if (isEditMode) {
  <span>
    @for (index of rattingArray ; track index) {
      <i class="fn-global-star-fill black"></i>
    }
  </span>
}